import React, { FC } from 'react';
import styles from './BoxHolder.module.scss';

type BoxHolderProps = {
    children?: React.ReactNode;
    className?: string;
}

const BoxHolder: FC<BoxHolderProps> = ({ children, className }) => {
    return (
        <div className={`${styles.boxHolder} ${className}`}>
            {children}
        </div>
    )
}

export default BoxHolder;